module.exports = __webpack_public_path__ + "img/img_golf_app2_en.929da934.png";